import text from "./text"

export default {
  "600": {
    ...text["600"],
  },
  // Default
  "500": {
    ...text["500"],
  },
  "400": {
    ...text["400"],
  },
  "300": {
    ...text["300"],
  },
}
